import Iphone from '../../src/legacy/Iphone';
export default Iphone;
